import { Button, Card, Col, Collapse, Descriptions, Dropdown, Icon, Row, Spin, Table, Tooltip } from 'antd';
import React from "react";
import './style.css';
import moment from "moment";
import MapView from "./MapView";
import { Link } from 'react-router-dom';
import AccessControl from '../../components/AccessControl';
import QuickActionBar from './QuickActionBar';
import FuelCalibrationLink from './FuelCalibrationLink';
import FuelManualReportLink from './FuelManualReportLink';
import OpsTicketsButton from './OpsTicketsButton';
import { findLinkedIotDevice } from './linkedIotDevice';
import ImagePreviewModal from '../../components/ImagePreviewModal';

const { Panel } = Collapse;

class HistoryReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMapVisible: false,
      mapData: null,
      photoPreview: { visible: false, index: 0, photos: [] }
    };
  }

  openPhotoPreview = (photos, index) => {
    const list = (photos || [])
      .filter((p) => p && p.url)
      .map((p, i) => ({ url: p.url, name: p.name || `Attachment ${i + 1}` }));
    this.setState({ photoPreview: { visible: true, index, photos: list } });
  };

  closePhotoPreview = () => {
    this.setState((prev) => ({ photoPreview: { ...prev.photoPreview, visible: false } }));
  };

  renderVerificationPhotos = (photos) => {
    if (!photos || !photos.length) return 'None';
    return (
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
        {photos.map((photo, ix) => (
          photo && photo.url ? (
            <img
              key={ix}
              src={photo.url}
              alt={photo.name || `Attachment ${ix + 1}`}
              title={photo.name || `Attachment ${ix + 1}`}
              onClick={() => this.openPhotoPreview(photos, ix)}
              style={{
                width: 44,
                height: 44,
                objectFit: 'cover',
                borderRadius: 4,
                border: '1px solid #d9d9d9',
                cursor: 'pointer',
              }}
            />
          ) : null
        ))}
      </div>
    );
  };

  hideMapVisible = () => {
    this.setState((prevState) => ({
      isMapVisible: false,
      mapData: null
    }))
  }

  componentDidMount() {
    const { match, fetch, location, qrScanLog } = this.props;
    this.props.clearQrScanLogData();
    if (match.params && match.params.id) {
      fetch(match.params.id);

      if (location && location.search && !location.search.includes("scanned")) {
        qrScanLog({ scannedAsset: match.params.id });
      }
    }

  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.qrScanLogSuccess && nextProps.qrScanLogSuccess !== this.props.qrScanLogSuccess) {
      const search = this.props.location.search + "&scanned=true";
      const path = this.props.location.pathname + search;
      this.props.history.push(path);
    }
  }

  dropdownData = (item, pushCostColumn, refurbish) => {
    const columns = [
      { title: 'Reading Value', dataIndex: 'value', key: 'value' },
      { title: 'Reading Unit', dataIndex: 'unit', key: 'unit' }
    ];

    if (pushCostColumn) {
      columns.push({ title: 'Cost', dataIndex: 'cost', key: 'cost' });
    } else if (refurbish) {
      columns.push({ title: 'Cost / Reading Unit', dataIndex: 'cost', key: 'cost' });
    } else {
    }

    return <React.Fragment>
      <Table
        style={{ width: '100%', backgroundColor: '#c0c9ff' }}
        columns={columns}
        dataSource={item}
        pagination={false}
      />
    </React.Fragment>
  };

  dropdownDataForAST = (item) => {
    const columns = [
      {
        title: 'Attachments', dataIndex: 'url', key: 'imageUrl',
        render: (data, record, index) => <div> {record && data ?
          <a style={{ display: 'block' }} key={record.url} href={`${record.url}`}
            target='_blank'>{`Attachment${index + 1}`}</a> : 'No Attachments'} </div>
      },
    ];


    return <React.Fragment>
      <Table
        style={{ width: '100%', backgroundColor: '#c0c9ff' }}
        columns={columns}
        dataSource={item}
        pagination={false}
      />
    </React.Fragment>
  };

  linkHandler = (_id, page, route) => {
    this.props.linkHandler(_id, page, route);
  };

  editDocumentHandler = (record) => {
    const { match } = this.props;
    this.props.history.push(`/document/edit/${record._id}`);
  }

  showMapView = (data) => {
    this.setState({
      isMapVisible: true,
      mapData: data,
    });
  }

  fuelConsumptionRateHistoryColumns = [
    {
      title: 'Asset Model', dataIndex: 'assetModel', key: 'assetModel',
      render: (assetModel) => (assetModel && assetModel.name) || 'NA'
    },
    {
      title: 'Meter', dataIndex: 'perType', key: 'perType',
      render: (perType) => (perType && perType.name) || 'NA'
    },
    { title: 'Fuel Qty (Rate)', dataIndex: 'fuelQty', key: 'fuelQty' },
    {
      title: 'Effective From', dataIndex: 'effectiveFrom', key: 'effectiveFrom',
      render: (date) => <div>{(date && moment(date).format('DD-MM-YYYY hh:mm a')) || 'NA'}</div>
    },
    {
      title: 'Effective To', dataIndex: 'effectiveTo', key: 'effectiveTo',
      render: (date) => <div>{date ? moment(date).format('DD-MM-YYYY hh:mm a') :
        <Icon type="check-circle" style={{ color: 'green' }} title="Current" />}</div>
    },
    {
      title: 'Changed By', dataIndex: 'changedBy', key: 'changedBy',
      render: (changedBy) => (changedBy && (changedBy.name || changedBy.email)) || 'NA'
    },
  ]

  render() {
    const { loading, title, resource, form, filters, assetTypes, equipmentSubTypes, report, match } = this.props;
    const { data } = this.props.data;
    // console.log(loading, data)

    const assetId = match.params.id;
    const {
      assetStockTakingData,
      assetTaggingDataData,
      assetCreatedFromPvData,
      assetPvReconData,
      assetConditionVoucherData
    } = data && data.assetStockTaking || {};
    // ACV rows are shaped like AST rows (record in assetDetails[0]) so the verification columns treat them alike
    const assetConditionVoucherRows = (assetConditionVoucherData || []).map((acv, index) => {
      const record = (acv && acv.assetConditions && acv.assetConditions[0]) || {};
      return {
        ...acv,
        key: `acv-${acv._id || index}`,
        assetDetails: [{ ...record, time: record.createdAt, manual: record.entryMode !== 'QR' }]
      };
    });
    const asset = data && data.asset;
    const fuelConsumptionRateHistory = (asset && asset.standardFuelConsumptionRateHistory || [])
      .map((item, index) => ({ ...item, key: index }));
    // const assetDocuments = [];
    const assetStockTaking = [
      ...(assetStockTakingData || []),
      ...(assetTaggingDataData || []),
      ...(assetCreatedFromPvData || []),
      ...(assetPvReconData || [])
    ];
    const assetTaggingVerificationData = (assetTaggingDataData || []).reduce((acc, item, index) => {
      if (!item) {
        return acc;
      }
      const scannerData = (item.scannerData && item.scannerData.length) ? item.scannerData[0] : null;
      acc.push({
        ...item,
        key: `${item._id || index}-link`,
        entryType: 'LINK',
        entryTime: item.createdAt
      });
      if (scannerData && scannerData.isUnlinked && scannerData.unlinkedAt) {
        acc.push({
          ...item,
          key: `${item._id || index}-unlink`,
          entryType: 'UNLINK',
          entryTime: scannerData.unlinkedAt
        });
      }
      return acc;
    }, []);
    const assetStockTakingForVerification = [
      ...(assetStockTakingData || []),
      ...assetTaggingVerificationData,
      ...(assetCreatedFromPvData || []),
      ...(assetPvReconData || []),
      ...assetConditionVoucherRows
    ];
    // console.log(assetStockTaking)

    // Last Located = the most recent time the asset was physically located, across
    // every verification event: AST scans (assetDetails.time), AT tagging
    // (createdAt) and PV records (pv.createdAt) - reconciliation links/new assets
    // as well as PV-approval created ones.
    const locatedDates = [];
    (assetStockTakingData || []).forEach(a => {
      (a && a.assetDetails || []).forEach(d => { if (d && d.time) locatedDates.push(d.time); });
    });
    (assetTaggingDataData || []).forEach(a => { if (a && a.createdAt) locatedDates.push(a.createdAt); });
    (assetPvReconData || []).forEach(a => { if (a && a.pv && a.pv.createdAt) locatedDates.push(a.pv.createdAt); });
    (assetCreatedFromPvData || []).forEach(a => { if (a && a.pv && a.pv.createdAt) locatedDates.push(a.pv.createdAt); });
    assetConditionVoucherRows.forEach(a => { if (a.assetDetails[0].time) locatedDates.push(a.assetDetails[0].time); });
    const lastLocated = locatedDates.length
      ? moment.max(locatedDates.map(d => moment(d)))
      : null;

    const documentColumns = [
      { title: 'Name', dataIndex: 'title', key: 'title' },
      // { title: 'Type', dataIndex: 'type', key: 'type' },
      {
        title: 'Renewal Date', dataIndex: 'renewalDate', key: 'renewalDate',
        render: (renewalDate) => <div>{renewalDate ? moment(renewalDate).format('DD-MM-YYYY') : "None"}</div>
      },
      {
        title: 'Document Date', dataIndex: 'documentDate', key: 'documentDate',
        render: (documentDate) => <div>{documentDate ? moment(documentDate).format('DD-MM-YYYY') : "None"}</div>
      },
      { title: 'Amount', dataIndex: 'amount', key: 'amount' },
      {
        title: 'Link to Document', dataIndex: 'href', key: 'href',
        render: (href) => {
          return (
            <a href={href} target="_blank">
              <span className="documentButton">
                Open Document
              </span>
            </a>
          );
        }
      },
      {
        title: 'Action',
        render: (record) => {
          return (
            <>
              {record && record._id ? (
                <Tooltip placement="topLeft" title={"Edit Document"}>
                  {/*<Button className='button-for-job-card' onClick={this.editDocumentHandler.bind(this,record)}>*/}
                  <Button className='button-for-job-card'
                    onClick={this.editDocumentHandler.bind(this, record)}
                  >
                    Edit Doc
                  </Button>
                </Tooltip>
              ) : <div>NA</div>
              }
            </>
          );
        }
      },
    ];

    let documentCost = 0;


    // asset && asset.documents && asset.documents.map((item, index) => {
    //   const document = {
    //     key: index,
    //     // title: item.file && item.file.name,
    //     title: item.name,
    //     type: item.type && item.type.name,
    //     renewalDate: item.renewalDate,
    //     documentDate: item.documentDate,
    //     amount: item.amount ? item.amount : 0,
    //     href: item.file && item.file.path,
    //     _id: item._id,
    //   };
    //   if (item.amount) {
    //     documentCost = documentCost + parseInt(item.amount);
    //   }
    //   assetDocuments.push(document);
    // });

    const groupedDocuments = asset && asset.documents ? asset.documents.reduce((acc, item) => {
      const type = item.type && item.type.name
      if (!acc[type]) {
        acc[type] = []
      }
      acc[type].push({
        key: item._id, // Assuming _id is unique
        title: item.name,
        renewalDate: item.renewalDate,
        documentDate: item.documentDate,
        amount: item.amount || 0,
        href: item.file && item.file.path,
        _id: item._id
      })
      return acc
    }, {}) : {}

    // Sort each document type array by _id in descending order
    Object.keys(groupedDocuments).forEach(type => {
      groupedDocuments[type].sort((a, b) => {
        if (a._id < b._id) return 1
        if (a._id > b._id) return -1
        return 0
      })
    })

    // Calculate document cost
    documentCost = asset && asset.documents ? asset.documents.reduce((total, item) => {
      return total + (parseInt(item.amount) || 0)
    }, 0) : 0


    // let totalDocumentCost = 0;
    // assetDocuments && assetDocuments.length > 0 && assetDocuments.map((item) => {
    //   totalDocumentCost = totalDocumentCost + parseInt(item.amount)
    // })

    const equipmentSubType = (asset && asset.equipmentSubType || {});
    const owner = (asset && asset.owner || {});
    const purchaseOrder = data && data.purchaseOrder;
    const getPurchaseOrderRateForAsset = (purchaseOrderData, assetData) => {
      if (!purchaseOrderData || !purchaseOrderData.assets || !purchaseOrderData.assets.length || !assetData || !assetData._id) {
        return 0;
      }

      const matchingPurchaseOrderAsset = purchaseOrderData.assets.find((poAsset) => {
        const purchaseOrderAssetId = poAsset && poAsset.asset && poAsset.asset._id
          ? poAsset.asset._id
          : poAsset && poAsset.asset;
        return purchaseOrderAssetId && purchaseOrderAssetId.toString() === assetData._id.toString();
      });

      return Number((matchingPurchaseOrderAsset && matchingPurchaseOrderAsset.rate) || 0);
    };
    const currentReportAssetRate = Number(
      asset && asset.rate !== undefined && asset.rate !== null
        ? asset.rate
        : getPurchaseOrderRateForAsset(purchaseOrder, asset)
    ) || 0;
    // console.log(purchaseOrder)
    const purchaseOrderReadings = [];
    purchaseOrder && purchaseOrder.assets && purchaseOrder.assets[0] && purchaseOrder.assets[0].service && purchaseOrder.assets[0].service.map((item, index) => {
      const reading = { key: index, value: item.interval, unit: item && item.unit && item.unit.name };
      purchaseOrderReadings.push(reading);
    });

    const assetServicing = data && data.assetServicing;
    const assetServicingReadings = [];
    assetServicing && assetServicing.readings && assetServicing.readings.map((item, index) => {
      const reading = { key: index, value: item.value, unit: item && item.unit && item.unit.name };
      assetServicingReadings.push(reading);
    });

    const assetRefurbishment = data && data.assetRefurbishment;

    const parentLinkedAsset = data && data.parentLinkedAsset, parentPurchaseOrderReadings = [];

    let movementData = {
      ata: data && data.ata,
      arn: data && data.arn,
      eai: data && data.eai,
      ear: data && data.ear
    };

    if (parentLinkedAsset && Object.keys(parentLinkedAsset).length) {
      movementData = {
        ata: parentLinkedAsset.ataData || [],
        arn: parentLinkedAsset.arnData || [],
      }
    }

    movementData && movementData.ata && movementData.ata.length > 0 && movementData.ata.map(item => {
      if (movementData.arn && movementData.arn.length > 0) {
        item.arn = movementData.arn.find(arn => arn.ata._id === item._id);
      }
    });
    movementData.eai = data && data.eai;
    movementData.ear = data && data.ear;
    const earColumns = [
      {
        title: 'Receipt Date', dataIndex: 'earDate', key: 'earDate',
        render: (date) => <div>{moment(date).format('DD-MM-YYYY')}</div>
      },
      {
        title: 'EAR No.', dataIndex: 'earNo', key: 'earNo',
        render: (ear) => {
          return (ear && ear._id && <Button
            onClick={this.linkHandler.bind(this, ear && ear._id, 'employee-asset-receipt', 'edit')}>{'Open ' + (ear && ear.issueNo)}
          </Button>) || <div>NA</div>
        }
      },
      { title: 'Employee Name', dataIndex: 'employee', key: 'employee' },
      { title: 'Received Location', dataIndex: 'receivedLocation', key: 'receivedLocation' },
      { title: 'Received Sub Location', dataIndex: 'receivedSubLocation', key: 'receivedSubLocation' },
      { title: 'Received By', dataIndex: 'receivedBy', key: 'receivedBy' },
      {
        title: 'Received Date', dataIndex: 'receivedDate', key: 'receivedDate',
        render: (date) => <div>{(date && moment(date).format('DD-MM-YYYY')) || ''}</div>
      },
    ]

    const movementEarData = movementData && movementData.ear && movementData.ear.map((item, index) => {
      const obj = {
        key: index,
        earDate: item.receiptDate,
        earNo: item,
        employee: item.employee && item.employee.name,
        receivedLocation: '',
        receivedSubLocation: '',
        receivedBy: item.receivedBy && item.receivedBy.name,
        receivedDate: item.receivedDate,
      }

      const filteredData = item.assets && item.assets.length && item.assets.find(item => item.asset._id === assetId);
      if (filteredData && filteredData.receivedLocation) {
        obj['receivedLocation'] = (filteredData.receivedLocation && filteredData.receivedLocation.name) || '';
      }
      if (filteredData && filteredData.receivedSubLocation) {
        obj['receivedSubLocation'] = (filteredData.receivedSubLocation && filteredData.receivedSubLocation.name) || '';
      }
      return obj;
    });

    const eaiColumns = [
      {
        title: 'Issue Date', dataIndex: 'eaiDate', key: 'eaiDate',
        render: (date) => <div>{moment(date).format('DD-MM-YYYY')}</div>
      },
      {
        title: 'EAI No.', dataIndex: 'eaiNo', key: 'eaiNo',
        render: (eai) => {
          return (eai && eai._id && <Button
            onClick={this.linkHandler.bind(this, eai && eai._id, 'employee-asset-issue', 'edit')}>{'Open ' + (eai && eai.issueNumber)}
          </Button>) || <div>NA</div>
        }
      },
      { title: 'Employee Name', dataIndex: 'employee', key: 'employee' },
      { title: 'Location', dataIndex: 'fromLocation', key: 'fromLocation' },
      { title: 'Authorised By', dataIndex: 'authorisedBy', key: 'authorisedBy' },
      {
        title: 'Authorised Date', dataIndex: 'authorisedDate', key: 'authorisedDate',
        render: (date) => <div>{(date && moment(date).format('DD-MM-YYYY')) || ''}</div>
      },
      { title: 'Received By', dataIndex: 'receivedBy', key: 'receivedBy' },
      {
        title: 'Received Date', dataIndex: 'receivedDate', key: 'receivedDate',
        render: (date) => <div>{date && moment(date).format('DD-MM-YYYY') || ''}</div>
      },
    ]

    const movementEaiData = movementData && movementData.eai && movementData.eai.map((item, index) => {
      return {
        key: index,
        eaiDate: item.issueDate,
        eaiNo: item,
        employee: item.employee && item.employee.name,
        fromLocation: item.location && item.location.name,
        authorisedBy: item.authorisedBy && item.authorisedBy.name,
        authorisedDate: item.authorisedDate,
        receivedBy: item.receivedBy && item.receivedBy.name,
        receivedDate: item.receivedDate
      }
    });

    const movementColumns = [
      {
        title: 'Date of ATA', dataIndex: 'ataDate', key: 'ataDate',
        render: (date) => <div>{moment(date).format('DD-MM-YYYY')}</div>
      },
      {
        title: 'ATA No.', dataIndex: 'ataNo', key: 'ataNo',
        render: (ata) => {
          return (ata && ata._id && <Button
            onClick={this.linkHandler.bind(this, ata && ata._id, 'asset-transfer-advice', 'edit')}>{'Open ' + (ata && ata.ataNo)}
          </Button>) || <div>NA</div>
        }
      },
      { title: 'From Location', dataIndex: 'fromLocation', key: 'fromLocation' },
      { title: 'From Sub Location', dataIndex: 'fromClient', key: 'fromClient' },
      { title: 'Mode of Transport', dataIndex: 'modeOfTransport', key: 'modeOfTransport' },
      { title: 'To Location', dataIndex: 'toLocation', key: 'toLocation' },
      { title: 'To Sub Location', dataIndex: 'toClient', key: 'toClient' },
      {
        title: 'ARN Date', dataIndex: 'arnDate', key: 'arnDate',
        render: (date) => <div>{(!isNaN(Date.parse(date)) && moment(date).format('DD-MM-YYYY')) || "NA"}</div>
      },
      {
        title: 'ARN No.', dataIndex: 'arnNo', key: 'arnNo',
        render: (arn) => {
          return (arn && arn._id && <Button
            onClick={this.linkHandler.bind(this, arn && arn._id, 'asset-receipt-note', 'edit')}>{'Open ' + (arn && arn.arnNo)}
          </Button>) || <div>NA</div>
        }
      },
      { title: 'Status', dataIndex: 'status', key: 'status' },
    ];

    const movementTableData = movementData && movementData.ata && movementData.ata.map((item, index) => {
      let client = null;
      if (item && item.assetClientMap && item.assetClientMap.length) {
        for (let i = 0; i < item.assetClientMap.length; i++) {
          let record = item.assetClientMap[i];
          if (record && record.asset && record.asset.assetCode && asset && asset.assetCode && record.asset.assetCode === asset.assetCode) {
            client = record.client && record.client.name;
          }
        }
      }
      return {
        key: index,
        ataDate: item.dispatchDate,
        ataNo: item,
        fromLocation: item.from && item.from.location && item.from.location.name,
        fromClient: client || (item.from && item.from.client && item.from.client.name),
        modeOfTransport: item.modeOfTransport,
        toLocation: item.to && item.to.location && item.to.location.name,
        toClient: item.to && item.to.client && item.to.client.name,
        arnDate: item.arn && item.arn.receivedBy && item.arn.receivedBy.date,
        arnNo: item.arn,
        status: item.ataStatus,
      }
    });


    parentLinkedAsset && parentLinkedAsset.purchaseOrder && parentLinkedAsset.purchaseOrder.assets && parentLinkedAsset.purchaseOrder.assets[0] && parentLinkedAsset.purchaseOrder.assets[0].service
      && parentLinkedAsset.purchaseOrder.assets[0].service.map((item, index) => {
        const reading = { key: index, value: item.interval, unit: item && item.unit && item.unit.name };
        parentPurchaseOrderReadings.push(reading);
      });

    parentLinkedAsset && parentLinkedAsset.assetRefurbishments && parentLinkedAsset.assetRefurbishments.length > 0 && parentLinkedAsset.assetRefurbishments.map((item, index) => {
      let key = 0;
      parentLinkedAsset.assetRefurbishments[index].newReadings = [];
      const cost = item.cost;

      item.readings && item.readings.map((item, idx) => {
        let newValue = item.value;
        if (index === 0 && parentPurchaseOrderReadings && parentPurchaseOrderReadings.length > 0
          && parentPurchaseOrderReadings.findIndex(ele => ele.unit.toLowerCase() === item.unit.name.toLowerCase()) !== -1) {
          newValue -= parentPurchaseOrderReadings.find(ele => ele.unit.toLowerCase() === item.unit.name.toLowerCase()).value;
        } else if (parentLinkedAsset.assetRefurbishments[index - 1] && parentLinkedAsset.assetRefurbishments[index - 1].readings && parentLinkedAsset.assetRefurbishments[index - 1].readings.length > 0
          && parentLinkedAsset.assetRefurbishments[index - 1].readings.findIndex(ele => ele.unit.name.toLowerCase() === item.unit.name.toLowerCase()) !== -1) {
          newValue -= parentLinkedAsset.assetRefurbishments[index - 1].readings.find(ele => ele.unit.name.toLowerCase() === item.unit.name.toLowerCase()).value;
        } else {
          newValue = item.value;
        }

        const costPerUnit = newValue > 0
          ? parseFloat(cost / newValue).toFixed(2)
          : parseFloat('0').toFixed(2);
        const reading = {
          key: key++,
          value: item.value,
          unit: item && item.unit && item.unit.name,
          cost: costPerUnit
        };
        parentLinkedAsset.assetRefurbishments[index].newReadings.push(reading);
      });

      if (index === 0) {
        parentPurchaseOrderReadings && parentPurchaseOrderReadings.length > 0 && parentPurchaseOrderReadings.map((itemm, idxx) => {
          if (parentLinkedAsset.assetRefurbishments[index].newReadings && parentLinkedAsset.assetRefurbishments[index].newReadings.length > 0) {
            if (parentLinkedAsset.assetRefurbishments[index].newReadings.findIndex(ele => ele.unit.toLowerCase() === itemm.unit.toLowerCase()) === -1) {
              const reading = {
                key: key++,
                value: 0,
                unit: itemm.unit,
                cost: 0
              };
              parentLinkedAsset.assetRefurbishments[index].newReadings.push(reading);
            }
          }
        });
      } else {
        parentLinkedAsset.assetRefurbishments[index - 1] && parentLinkedAsset.assetRefurbishments[index - 1].newReadings && parentLinkedAsset.assetRefurbishments[index - 1].newReadings.length > 0
          && parentLinkedAsset.assetRefurbishments[index - 1].newReadings.map((itemm, idxx) => {
            if (parentLinkedAsset.assetRefurbishments[index].newReadings.findIndex(ele => ele.unit.toLowerCase() === itemm.unit.toLowerCase()) === -1) {
              const reading = {
                key: key++,
                value: 0,
                unit: itemm.unit,
                cost: 0
              };
              parentLinkedAsset.assetRefurbishments[index].newReadings.push(reading);
            }
          });
      }
    });

    const parentRefurbishmentData = parentLinkedAsset && parentLinkedAsset.assetRefurbishments && parentLinkedAsset.assetRefurbishments.length > 0 && parentLinkedAsset.assetRefurbishments.map((item, idx) => {
      return {
        key: idx,
        date: item.date,
        description: item.description,
        readings: item.newReadings,
        cost: item.cost >= 0 && item.cost.toLocaleString('en-IN', {
          maximumFractionDigits: 2,
          style: 'currency',
          currency: 'INR'
        }),
      }
    });

    const saleOrder = data && data.saleOrder;
    const saleOrderAsset = saleOrder && saleOrder.assets && saleOrder.assets.find(ele => ele.asset === assetId);
    const saleOrderReadings = [];
    let saleOrderCost = saleOrderAsset && saleOrderAsset.rate;

    saleOrderAsset && saleOrderAsset.service.map((item, index) => {
      const reading = { key: index, value: item.interval, unit: item && item.unit && item.unit.name };
      saleOrderReadings.push(reading);
    });

    let assetRefurbishmentCost = 0;
    const assetRefurbishmentColumns = [
      {
        title: 'Date', dataIndex: 'date', key: 'date',
        render: (date) => <div>{moment(date).format('DD-MM-YYYY')}</div>
      },
      { title: 'Description', dataIndex: 'description', key: 'description' },
      { title: 'Cost', dataIndex: 'cost', key: 'cost' },
      {
        title: 'Readings', dataIndex: 'readings', key: 'readings',
        render: (readings) => <Dropdown overlay={this.dropdownData.bind(this, readings, false, true)}
          trigger={['click']}>
          <a className="ant-dropdown-link" href="#">
            Click Here <Icon type="down" />
          </a>
        </Dropdown>
      },
    ];

    const assetRefurbishmentData = assetRefurbishment && assetRefurbishment.map((item, idx) => {
      let key = 0;
      const cost = item.cost;

      assetRefurbishmentCost += item.cost;
      assetRefurbishment[idx].newReadings = [];

      item.readings && item.readings.map((item, index) => {
        let newValue = item.value;
        if (idx === 0 && purchaseOrderReadings && purchaseOrderReadings.length > 0
          && purchaseOrderReadings.findIndex(ele => ele.unit.toLowerCase() === item.unit.name.toLowerCase()) !== -1) {
          newValue -= purchaseOrderReadings.find(ele => ele.unit.toLowerCase() === item.unit.name.toLowerCase()).value;
        } else if (assetRefurbishment[idx - 1] && assetRefurbishment[idx - 1].readings && assetRefurbishment[idx - 1].readings.length > 0
          && assetRefurbishment[idx - 1].readings.findIndex(ele => ele.unit.name.toLowerCase() === item.unit.name.toLowerCase()) !== -1) {
          newValue -= assetRefurbishment[idx - 1].readings.find(ele => ele.unit.name.toLowerCase() === item.unit.name.toLowerCase()).value;
        } else {
          newValue = item.value;
        }

        const costPerUnit = newValue > 0
          ? parseFloat(cost / newValue).toFixed(2)
          : parseFloat('0').toFixed(2);
        const reading = {
          key: key++,
          value: item.value,
          unit: item && item.unit && item.unit.name,
          cost: costPerUnit
        };
        assetRefurbishment[idx].newReadings.push(reading);
      });

      if (idx === 0) {
        purchaseOrderReadings && purchaseOrderReadings.length > 0 && purchaseOrderReadings.map((itemm, idxx) => {
          if (assetRefurbishment[idx].newReadings && assetRefurbishment[idx].newReadings.length > 0) {
            if (assetRefurbishment[idx].newReadings.findIndex(ele => ele.unit.toLowerCase() === itemm.unit.toLowerCase()) === -1) {
              const reading = {
                key: key++,
                value: 0,
                unit: itemm.unit,
                cost: 0
              };
              assetRefurbishment[idx].newReadings.push(reading);
            }
          }
        });
      } else {
        assetRefurbishment[idx - 1] && assetRefurbishment[idx - 1].newReadings && assetRefurbishment[idx - 1].newReadings.length > 0
          && assetRefurbishment[idx - 1].newReadings.map((itemm, index) => {
            if (assetRefurbishment[idx].newReadings.findIndex(ele => ele.unit.toLowerCase() === itemm.unit.toLowerCase()) === -1) {
              const reading = {
                key: key++,
                value: 0,
                unit: itemm.unit,
                cost: 0
              };
              assetRefurbishment[idx].newReadings.push(reading);
            }
          });
      }

      return {
        key: idx,
        date: item.date,
        description: item.description,
        readings: item.newReadings,
        cost: item.cost >= 0 && item.cost.toLocaleString('en-IN', {
          maximumFractionDigits: 2,
          style: 'currency',
          currency: 'INR'
        }),
      };
    });

    const dependentHistory = (data && data.dependentLinkHistory || []);
    // console.log(`dependentHistory:: `, dependentHistory)
    let dependentHistoryData = [];
    // let totalDays = 0;
    let totalDependentCost = 0;
    dependentHistory.forEach(item => {
      // For each history entry in the subasset, create a record
      // const associatedParents = [];
      let totalParentDays = 0;
      item.history.sort((a, b) => (a.linkedDate - b.linkedDate));
      item.history.forEach((historyEntry, index) => {
        // Calculate days in operation
        const startDate = moment(historyEntry.linkedDate).startOf('day');
        // Check next history entry's linkedDate for delink date calculation
        const nextHistoryEntry = item.history[index + 1]

        const endDate = historyEntry.delinkedDate ? moment(historyEntry.delinkedDate).startOf('day')
          : nextHistoryEntry ? moment(nextHistoryEntry.linkedDate).startOf('day') : moment().startOf('day');
        const daysInOperation = endDate.diff(startDate, 'days');
        totalParentDays += daysInOperation;

        if (historyEntry.isCurrentParent) {
          // const allocation_percentage = ((daysInOperation / totalParentDays) * 100).toFixed(2);
          // const allocated_amount = ((item.subasset.rate * daysInOperation / totalParentDays)).toFixed(2);
          // totalDependentCost += Number(allocated_amount);
          dependentHistoryData.push({
            asset: item.subasset,
            equipmentSubType: item.subasset.equipmentSubType && item.subasset.equipmentSubType.name,
            model: item.subasset.assetModel && item.subasset.assetModel.name,
            linkedOn: historyEntry.linkedDate,
            delinkedOn: historyEntry.delinkedDate,
            linkedTransferNo: historyEntry.linkedTransferNo,
            linkedTransferId: historyEntry.linkedTransferId,
            delinkedTransferNo: historyEntry.delinkedTransferNo,
            delinkedTransferId: historyEntry.delinkedTransferId,
            isCurrent: !historyEntry.delinkedDate,
            rate: item.subasset.rate,
            days: daysInOperation,
            // allocation_percentage: allocation_percentage,
            // allocated_amount: allocated_amount
          });
        }
      });

      // Calculate percentages and amounts in a single loop
      dependentHistoryData.forEach(record => {
        if (record.asset && record.asset._id === item.subasset._id) {
          record.allocation_percentage = ((record.days / totalParentDays) * 100).toFixed(2);
          record.allocated_amount = ((record.rate * record.days / totalParentDays)).toFixed(2);
          totalDependentCost += (record.rate * record.days / totalParentDays);
        }
      });

      totalParentDays = 0;
    });

    // Calculate percentages and amounts in a single loop
    // dependentHistoryData.forEach(record => {
    //   record.allocation_percentage = ((record.days / totalParentDays) * 100).toFixed(2);
    //   record.allocated_amount = ((record.rate * record.days / totalParentDays)).toFixed(2);
    //   totalDependentCost += (record.rate * record.days / totalParentDays);
    // });
    // dependentHistoryData = dependentHistoryData.filter(record => record)

    // Sort by linkedOn date in descending order
    dependentHistoryData.sort((a, b) => {
      if (a.linkedOn < b.linkedOn) return 1;
      if (a.linkedOn > b.linkedOn) return -1;
      return 0;
    });

    // console.log(`dependentHistoryData:: `, dependentHistoryData)
    // console.log(`totalDependentCost:: `, totalDependentCost)

    const dependentHistoryColumns = [
      {
        title: 'Asset Number', dataIndex: 'asset', key: 'asset',
        render: (asset) => <div>
          <Button
            onClick={this.linkHandler.bind(this, asset && asset._id, 'asset', 'history-report')}>{'Open ' + (asset && asset.assetCode)}
          </Button>
          <div style={{ fontSize: 12, opacity: 0.75, marginTop: 2 }}>
            {(asset && asset.altName) || '---'} / {(asset && asset.ownerCode) || '---'}
          </div>
        </div>
      },
      {
        title: 'Active', dataIndex: 'isCurrent', key: 'isCurrent',
        render: (isCurrent) => <div>{isCurrent ? <Icon type="check-circle" style={{ color: 'green' }} /> : null}</div>
      },
      { title: 'Sub Type', dataIndex: 'equipmentSubType', key: 'equipmentSubType' },
      { title: 'Model', dataIndex: 'model', key: 'model' },
      {
        title: 'Linked On', dataIndex: 'linkedOn', key: 'linkedOn',
        render: (date) => <div>{(!isNaN(Date.parse(date)) && moment(date).format('DD-MM-YYYY')) || date}</div>
      },
      {
        title: 'Delinked On', dataIndex: 'delinkedOn', key: 'delinkedOn',
        render: (date) => <div>{(!isNaN(Date.parse(date)) && moment(date).format('DD-MM-YYYY')) || date}</div>
      },
      {
        title: 'Rate', dataIndex: 'rate', key: 'rate',
        render: (rate) => <div>{rate.toLocaleString('en-IN', {
          maximumFractionDigits: 2,
          style: 'currency',
          currency: 'INR'
        })}</div>
      },
      { title: 'Days', dataIndex: 'days', key: 'days' },
      {
        title: 'Allocation Percentage', dataIndex: 'allocation_percentage', key: 'allocation_percentage',
        render: (allocation_percentage) => <div>{allocation_percentage}%</div>
      },
      {
        title: 'Allocated Amount', dataIndex: 'allocated_amount', key: 'allocated_amount',
        render: (allocated_amount) => <div>{allocated_amount.toLocaleString('en-IN', {
          maximumFractionDigits: 2,
          style: 'currency',
          currency: 'INR'
        })}</div>
      },
    ]

    // Parent linking history (similar to dependent)
    const parentLinkingHistory = (data && data.parentLinkingHistory) || []
    // console.log(`parentLinkingHistory:: `, parentLinkingHistory)
    let parentHistoryData = []
    let totalParentCost = 0
    parentLinkingHistory.forEach(item => {
      let totalChildDays = 0
      item.history.sort((a, b) => (a.linkedDate - b.linkedDate))
      item.history.forEach((historyEntry, index) => {
        const startDate = moment(historyEntry.linkedDate).startOf('day')
        const nextHistoryEntry = item.history[index + 1]
        const endDate = historyEntry.delinkedDate ? moment(historyEntry.delinkedDate).startOf('day')
          : nextHistoryEntry ? moment(nextHistoryEntry.linkedDate).startOf('day') : moment().startOf('day')
        const daysInOperation = endDate.diff(startDate, 'days')
        totalChildDays += daysInOperation

        // Treat current link as active row
        if (item.parentAsset) {
          parentHistoryData.push({
            asset: item.parentAsset,
            equipmentSubType: item.parentAsset && item.parentAsset.equipmentSubType && item.parentAsset.equipmentSubType.name,
            model: item.parentAsset && item.parentAsset.assetModel && item.parentAsset.assetModel.name,
            linkedOn: historyEntry.linkedDate,
            delinkedOn: historyEntry.delinkedDate,
            linkedTransferNo: historyEntry.linkedTransferNo,
            linkedRecordId: historyEntry.linkedRecordId,
            delinkedTransferNo: historyEntry.delinkedTransferNo,
            delinkedRecordId: historyEntry.delinkedRecordId,
            isCurrent: !historyEntry.delinkedDate,
            rate: currentReportAssetRate,
            days: daysInOperation,
          })
        }
      })

      // Calculate percentages and amounts for this parent
      parentHistoryData.forEach(record => {
        if (record.asset && item.parentAsset && record.asset._id === item.parentAsset._id) {
          record.allocation_percentage = ((record.days / (totalChildDays || 1)) * 100).toFixed(2)
          record.allocated_amount = ((record.rate * record.days / (totalChildDays || 1))).toFixed(2)
          totalParentCost += (record.rate * record.days / (totalChildDays || 1))
        }
      })
    })

    parentHistoryData.sort((a, b) => {
      if (a.linkedOn < b.linkedOn) return 1
      if (a.linkedOn > b.linkedOn) return -1
      return 0
    })

    // console.log(`parentHistoryData:: `, parentHistoryData)

    const parentHistoryColumns = [
      {
        title: 'Asset Number', dataIndex: 'asset', key: 'asset',
        render: (asset) => <div>
          <Button
            onClick={this.linkHandler.bind(this, asset && asset._id, 'asset', 'history-report')}>{'Open ' + (asset && asset.assetCode)}
          </Button>
          <div style={{ fontSize: 12, opacity: 0.75, marginTop: 2 }}>
            {(asset && asset.altName) || '---'} / {(asset && asset.ownerCode) || '---'}
          </div>
        </div>
      },
      {
        title: 'Active', dataIndex: 'isCurrent', key: 'isCurrent',
        render: (isCurrent) => <div>{isCurrent ? <Icon type="check-circle" style={{ color: 'green' }} /> : null}</div>
      },
      { title: 'Sub Type', dataIndex: 'equipmentSubType', key: 'equipmentSubType' },
      { title: 'Model', dataIndex: 'model', key: 'model' },
      {
        title: 'Linked On', dataIndex: 'linkedOn', key: 'linkedOn',
        render: (date) => <div>{(!isNaN(Date.parse(date)) && moment(date).format('DD-MM-YYYY')) || date}</div>
      },
      {
        title: 'Delinked On', dataIndex: 'delinkedOn', key: 'delinkedOn',
        render: (date) => <div>{(!isNaN(Date.parse(date)) && moment(date).format('DD-MM-YYYY')) || date}</div>
      },
      {
        title: 'Rate', dataIndex: 'rate', key: 'rate',
        render: (rate) => <div>{(Number(rate) || 0).toLocaleString('en-IN', {
          maximumFractionDigits: 2,
          style: 'currency',
          currency: 'INR'
        })}</div>
      },
      { title: 'Days', dataIndex: 'days', key: 'days' },
      {
        title: 'Allocation Percentage', dataIndex: 'allocation_percentage', key: 'allocation_percentage',
        render: (allocation_percentage) => <div>{allocation_percentage}%</div>
      },
      {
        title: 'Allocated Amount', dataIndex: 'allocated_amount', key: 'allocated_amount',
        render: (allocated_amount) => <div>{(Number(allocated_amount) || 0).toLocaleString('en-IN', {
          maximumFractionDigits: 2,
          style: 'currency',
          currency: 'INR'
        })}</div>
      },
    ]


    const dependentLinkedAssets = (data && data.dependentLinkedAsset || []);
    let dependentLinkedAssetCost = dependentLinkedAssets && dependentLinkedAssets.reduce((a, b) => a + (b['rate'] || 0), 0);
    const dependentLinkedAssetsColumns = [
      {
        title: 'Asset Number', dataIndex: 'assetNumber', key: 'assetNumber',
        render: (asset) => <Button
          onClick={this.linkHandler.bind(this, asset && asset._id, 'asset', 'history-report')}>{'Open ' + (asset && asset.assetCode)}
        </Button>
      },
      { title: 'Linked Equipment Sub Type', dataIndex: 'equipmentSubType', key: 'equipmentSubType' },
      { title: 'Linked Equipment Type', dataIndex: 'equipmentType', key: 'equipmentType' },
      {
        title: 'Linked On', dataIndex: 'linkedOn', key: 'linkedOn',
        render: (date) => <div>{(!isNaN(Date.parse(date)) && moment(date).format('DD-MM-YYYY')) || date}</div>
      },
      {
        title: 'Delinked On', dataIndex: 'delinkedOn', key: 'delinkedOn',
        render: (date) => <div>{(!isNaN(Date.parse(date)) && moment(date).format('DD-MM-YYYY')) || date}</div>
      },
    ];

    const dependentLinkedAssetsData = dependentLinkedAssets && dependentLinkedAssets.map((asset, idx) => {
      const assetPurchaseOrderReadings = [];

      asset.purchaseOrder && asset.purchaseOrder.assets && asset.purchaseOrder.assets[0] && asset.purchaseOrder.assets[0].service
        && asset.purchaseOrder.assets[0].service.map((item, index) => {
          const reading = { key: index, value: item.interval, unit: item && item.unit && item.unit.name };
          assetPurchaseOrderReadings.push(reading);
        });

      asset.assetRefurbishments && asset.assetRefurbishments.length > 0 && asset.assetRefurbishments.map((item, index) => {
        const cost = item.cost;
        let key = 0;
        asset.assetRefurbishments[index].newReadings = [];

        item.readings && item.readings.map((item, idx) => {
          let newValue = item.value;
          if (index === 0 && assetPurchaseOrderReadings && assetPurchaseOrderReadings.length > 0
            && assetPurchaseOrderReadings.findIndex(ele => ele.unit.toLowerCase() === item.unit.name.toLowerCase()) !== -1) {
            newValue -= assetPurchaseOrderReadings.find(ele => ele.unit.toLowerCase() === item.unit.name.toLowerCase()).value;
          } else if (asset.assetRefurbishments[index - 1] && asset.assetRefurbishments[index - 1].readings && asset.assetRefurbishments[index - 1].readings.length > 0
            && asset.assetRefurbishments[index - 1].readings.findIndex(ele => ele.unit.name.toLowerCase() === item.unit.name.toLowerCase()) !== -1) {
            newValue -= asset.assetRefurbishments[index - 1].readings.find(ele => ele.unit.name.toLowerCase() === item.unit.name.toLowerCase()).value;
          } else {
            newValue = item.value;
          }

          const costPerUnit = newValue > 0
            ? parseFloat(cost / newValue).toFixed(2)
            : parseFloat('0').toFixed(2);
          const reading = {
            key: key++,
            value: item.value,
            unit: item && item.unit && item.unit.name,
            cost: costPerUnit
          };
          asset.assetRefurbishments[index].newReadings.push(reading);
        });

        if (index === 0) {
          assetPurchaseOrderReadings && assetPurchaseOrderReadings.length > 0 && assetPurchaseOrderReadings.map((itemm, idxx) => {
            if (asset.assetRefurbishments[index].newReadings && asset.assetRefurbishments[index].newReadings.length > 0) {
              if (asset.assetRefurbishments[index].newReadings.findIndex(ele => ele.unit.toLowerCase() === itemm.unit.toLowerCase()) === -1) {
                const reading = {
                  key: key++,
                  value: 0,
                  unit: itemm.unit,
                  cost: 0
                };
                asset.assetRefurbishments[index].newReadings.push(reading);
              }
            }
          });
        } else {
          asset.assetRefurbishments[index - 1] && asset.assetRefurbishments[index - 1].newReadings && asset.assetRefurbishments[index - 1].newReadings.length > 0
            && asset.assetRefurbishments[index - 1].newReadings.map((itemm, idxx) => {
              if (asset.assetRefurbishments[index].newReadings.findIndex(ele => ele.unit.toLowerCase() === itemm.unit.toLowerCase()) === -1) {
                const reading = {
                  key: key++,
                  value: 0,
                  unit: itemm.unit,
                  cost: 0
                };
                asset.assetRefurbishments[index].newReadings.push(reading);
              }
            });
        }
      });
      return {
        key: idx,
        assetNumber: asset,
        equipmentSubType: asset.equipmentSubType && asset.equipmentSubType.name,
        equipmentType: asset.equipmentSubType && asset.equipmentSubType.assetType && asset.equipmentSubType.assetType.name,
        linkedOn: asset.linkedOn,
        delinkedOn: asset.delinkedOn,
        refurbishments: asset.assetRefurbishments,
      }
    });


    dependentLinkedAssetsData.sort(function (a, b) {
      if (a.linkedOn < b.linkedOn) {
        return 1;
      }
      if (a.linkedOn > b.linkedOn) {
        return -1;
      }
      return 0;
    });


    const dependentRefurbishments = (item) => {
      const data = item.refurbishments && item.refurbishments.length > 0 && item.refurbishments.map((ele, index) => {
        return {
          key: index,
          date: ele.date,
          description: ele.description,
          readings: ele.newReadings,
          cost: ele.cost >= 0 && ele.cost.toLocaleString('en-IN', {
            maximumFractionDigits: 2,
            style: 'currency',
            currency: 'INR'
          }),
        };
      });

      return (
        <div>
          <span className="ant-table-column-title" style={{ fontWeight: '500' }}>Asset Refurbishments</span>
          <Table style={{ marginTop: '10px' }} columns={assetRefurbishmentColumns || []} dataSource={data || []}
            pagination={false} bordered={true} />
        </div>
      );
    };

    let jobCardTotalCost = 0;
    // let purchaseOrderCost = purchaseOrder && purchaseOrder.assets && purchaseOrder.assets[0] && purchaseOrder.assets[0].rate;
    let purchaseOrderCost = getPurchaseOrderRateForAsset(purchaseOrder, asset);
    let parentLinkedAssetPurchaseOrderCost = parentLinkedAsset && parentLinkedAsset.purchaseOrder && parentLinkedAsset.purchaseOrder.assets && parentLinkedAsset.purchaseOrder.assets[0] && parentLinkedAsset.purchaseOrder.assets[0].rate;


    const jobCards = (data && data.jobCard || []);
    const jobCardsColumns = [
      {
        title: 'Date of Job Card', dataIndex: 'jobCardDate', key: 'jobCardDate',
        render: (jobCardDate) => <div>{moment(jobCardDate).format('DD-MM-YYYY')}</div>,
        sorter: (a, b) => moment(b.jobCardDate).valueOf() - moment(a.jobCardDate).valueOf(),
        sortDirections: ['descend', 'ascend'],
        defaultSortOrder: 'descend'
      },
      {
        title: 'Job Card No.', dataIndex: 'jobCardNumber', key: 'jobCardNumber',
        render: (jobCard) => <Button
          onClick={this.linkHandler.bind(this, jobCard && jobCard._id, 'job-card', 'report')}>{'Open ' + (jobCard && jobCard.jobCardNo)}
        </Button>
      },
      { title: 'Complaint Details', dataIndex: 'complaintDetails', key: 'complaintDetails' },
      { title: 'Complaint Date', dataIndex: 'complaintDate', key: 'complaintDate' },
      { title: 'Total Job Card Cost', dataIndex: 'totalCost', key: 'totalCost' },
      { title: 'Adhoc / Scheduled', dataIndex: 'status', key: 'status' },
      { title: 'Close Date', dataIndex: 'closureDate', key: 'closureDate' },
      {
        title: 'Readings', dataIndex: 'readings', key: 'readings',
        render: (readings) => <Dropdown overlay={this.dropdownData.bind(this, readings, false, false)}
          trigger={['click']}>
          <a className="ant-dropdown-link" href="#">
            Click Here <Icon type="down" />
          </a>
        </Dropdown>
      },
    ];

    const jobCardsData = jobCards && jobCards.map((item, index) => {
      if (item) {
        let totalCost = 0;
        totalCost = totalCost + item.invoiceCost;
        // item.activities && item.activities.length > 0 && item.activities.map(activity => {
        //   activity.allocate && activity.allocate.length > 0 && activity.allocate.map(ele => {
        //     let time = 0, rate = (ele.manpower && ele.manpower.rate) || 0;
        //     if (ele.manpowerPerformance && ele.manpowerPerformance.maintenance && ele.manpowerPerformance.maintenance.length > 0
        //       && ele.manpowerPerformance.maintenance.findIndex(i => i.jobCardActivityNumber === activity._id) !== -1
        //       && ele.manpowerPerformance.employee === (ele.manpower && ele.manpower._id)) {
        //       const performance = ele.manpowerPerformance.maintenance.find(i => i.jobCardActivityNumber === activity._id);
        //       time = (performance.hour / 60);
        //     } else {
        //       totalCost = item.jobcardTotalAmount;
        //     }
        //     totalCost += rate * time;
        //   });
        // });
        if (totalCost) {
          jobCardTotalCost += totalCost;
        }
        const readings = [];
        item.complaint && item.complaint.service && item.complaint.service.map((item, index) => {
          const reading = { key: index, value: item.interval, unit: item.unit && item.unit.name };
          readings.push(reading);
        });

        return {
          key: index,
          jobCardDate: item.createdAt,
          jobCardNumber: item,
          totalCost: totalCost && totalCost >= 0 ? totalCost.toLocaleString('en-IN', {
            maximumFractionDigits: 2,
            style: 'currency',
            currency: 'INR'
          }) : 0.00.toLocaleString('en-IN', {
            maximumFractionDigits: 2,
            style: 'currency',
            currency: 'INR'
          }),
          status: item.complaint && item.complaint.complaintType,
          complaintDetails: item.complaint && item.complaint.detailsOfComplaint,
          complaintDate: item.complaint && item.complaint.complaintDate && moment(item.complaint.complaintDate).format('DD-MM-YYYY'),
          closureDate: (item.closureDate && moment(item.closureDate).format('DD-MM-YYYY')) || '',
          readings: readings,
        }
      }
    });

    //     const dataOfJob={}
    //     jobCardsData.map(async (item1)=>{
    //       dataOfJob.name=item1;
    //       const activitiesData= item1.jobCardNumber.activities;
    //       for (let i = 0; i < activitiesData.length; i++) {
    //         const item = activitiesData[i];
    //         const obj = Object.assign({});
    //         for (let j = 0; j < item.allocate.length; j++) {
    //           const allocateItem= item.allocate[j];
    //           const finalForCalculation=allocateItem.manpower;
    //           console.log('rate',finalForCalculation.rate );
    //
    //         }
    //       }
    //     });


    //const totalAssetCost = (purchaseOrderCost || parentLinkedAssetPurchaseOrderCost) + jobCardTotalCost + dependentLinkedAssetCost + assetRefurbishmentCost - saleOrderCost;
    if (!purchaseOrderCost) {
      purchaseOrderCost = 0;
    }
    if (!jobCardTotalCost) {
      jobCardTotalCost = 0;
    }
    if (!dependentLinkedAssetCost) {
      dependentLinkedAssetCost = 0;
    }
    if (!assetRefurbishmentCost) {
      assetRefurbishmentCost = 0;
    }
    if (!saleOrderCost) {
      saleOrderCost = 0;
    }
    let totalAssetCost = (purchaseOrderCost) + documentCost + jobCardTotalCost + dependentLinkedAssetCost + (totalDependentCost || 0) + assetRefurbishmentCost - saleOrderCost;
    // console.log(`totalAssetCost:: `, totalAssetCost, totalDependentCost)

    const assetStockTakingColumn = [
      {
        title: 'Verification Id', dataIndex: 'vNo', key: 'vNo',
        render: (_, data) => {
          if (data && data['code']) {
            return data['code'];
          } else if (data && data['pvAppNo']) {
            return data && data['pv'] && data['pv']['location'] && data['pv']['pvNo'];
          } else if (data && (data['astNo'] || data['acvNo'])) {
            return data['astNo'] || data['acvNo'];
          }
        }
      },
      {
        title: 'Location', dataIndex: 'location', key: 'location',
        render: (_, data) => {
          if (data && data['code']) {
            return '-';
          } else if (data && data['pvAppNo']) {
            return data && data['pv'] && data['pv']['location'] && data['pv']['location']['name'];
          } else if (data && (data['astNo'] || data['acvNo'])) {
            return data && data['location'] && data['location'].name;
          }
        }
      },
      {
        title: 'Client', dataIndex: 'client', key: 'client',
        render: (_, data) => {
          if (data && data['code']) {
            return '-';
          } else if (data && data['pvAppNo']) {
            return data && data['pv'] && data['pv']['client'] && data['pv']['client']['name'];
          } else if (data && (data['astNo'] || data['acvNo'])) {
            return data && data['client'] && data['client'].name;
          }
        }
      },
      // {
      //     title: 'Asset Code', dataIndex: 'assetCode', key: 'assetCode',
      //     render: (_, data) => {
      //         if (data && data['code']) {
      //             return data && data['asset'] && data['asset'].assetCode;
      //         } else if (data && data['pvAppNo']) {
      //             return data && data['asset'] && data['asset'].assetCode;
      //         } else if (data && data['astNo']) {
      //             return data && data['assetDetails'] && data['assetDetails'][0].assetCode;
      //         }
      //     }
      // },
      {
        title: 'Condition', dataIndex: 'assetDetails', key: 'condition',
        render: (data) => <div>{data && data[0] && data[0].condition && data[0].condition.name}</div>
      },
      {
        title: 'Time', dataIndex: 'assetDetails', key: 'locatedAt',
        render: (_, data) => {
          if (data && data['code']) {
            const entryTime = data && (data['entryTime'] || data['createdAt']);
            return entryTime ? moment(entryTime).format('DD-MM-YYYY hh:mm a') : 'NA'
          } else if (data && data['pvAppNo']) {
            return data && data['pv'] && data['pv']['createdAt'] && moment(data['pv']['createdAt']).format('DD-MM-YYYY hh:mm a') || 'NA'
          } else if (data && (data['astNo'] || data['acvNo'])) {
            return data && data['assetDetails'] && data['assetDetails'][0].time && moment(data['assetDetails'][0].time).format('DD-MM-YYYY hh:mm a') || 'NA'
          }
        }

      },
      {
        title: 'Entry Type', dataIndex: 'assetDetails', key: 'manual',
        render: (_, data) => {
          if (data && data['code']) {
            return data && data['entryType'] || 'LINK'
          } else if (data && (data['astNo'] || data['acvNo'])) {
            return data && data['assetDetails'] && data['assetDetails'][0].manual ? 'Manual' : 'QR Code'
          } else if (data && data['reconAction']) {
            return data['reconAction'] === 'LINK_ASSET' ? 'PV LINK'
              : data['reconAction'] === 'NEW_ASSET' ? 'PV NEW ASSET' : 'PV'
          } else
            return '-'
        },
      },
      {
        title: 'Tag Type', dataIndex: 'tagType', key: 'tagType',
        render: (_, data) => {
          const scannerData = (data['scannerData'] && data['scannerData'].length) ? data['scannerData'][0] : null;
          // console.log(scannerData);
          return scannerData && scannerData['tag_type'] && scannerData['tag_type']['name'] || ''
        }
      },
      {
        title: 'Lat/Lng', dataIndex: 'latitude', key: 'latitude',
        render: (_, data) => {
          let lat = 0, lng = 0;
          if (data && data['code']) {
            if (data && data['latitude']) {
              lat = data['latitude'];
              lng = data['longitude'];
            }
            return (lat && lng) ? <Button
              type={'link'}
              onClick={() => this.showMapView(data)}><i className='icon-map-drawing' /></Button> : null;
          } else if (data && data['pvAppNo']) {
            if (data && data['pv'] && data['pv']['latitude']) {
              lat = data['pv']['latitude'];
              lng = data['pv']['longitude'];
            }
            return (lat && lng) ? <Button
              type={'link'}
              onClick={() => this.showMapView(data)}><i className='icon-map-drawing' /></Button> : null;
          } else if (data && (data['astNo'] || data['acvNo'])) {
            if (data && data['assetDetails'] && data['assetDetails'][0] && data['assetDetails'][0]['latitude']) {
              lat = data['assetDetails'][0]['latitude'];
              lng = data['assetDetails'][0]['longitude'];
            }
            return (lat && lng) ? <Button
              type={'link'}
              onClick={() => this.showMapView(data)}><i className='icon-map-drawing' /></Button> : null;
          }
        }
      },

      {
        title: 'Photos', dataIndex: 'assetDetails', key: 'photos',
        render: (_, data) => {
          if (data && data['code']) {
            return <div>{this.renderVerificationPhotos(data.photos)}</div>
          } else if (data && data['pvAppNo']) {
            return <div>{this.renderVerificationPhotos(data['assetDetails'] && data['assetDetails'].photos)}</div>
          } else if (data && (data['astNo'] || data['acvNo'])) {
            return <div>{this.renderVerificationPhotos(data['assetDetails'] && data['assetDetails'][0] && data['assetDetails'][0].photos)}</div>
          }

        }
      },
    ];
    const purchaseOrderCostData = purchaseOrderCost;
    // console.log(data)
    return (
      <>
        <Card className={`gx-card-metrics history-report-style`}>
          <QuickActionBar data={data} authUser={this.props.authUser} />
          <Spin spinning={loading || !data}>
            <div style={{ marginTop: '5px' }}>
              <Descriptions
                title="Asset History Report"
                layout='vertical'
                bordered
                column={{ xxl: 6, xl: 6, lg: 6, md: 3, sm: 2, xs: 1 }}
              >
                <Descriptions.Item label="Asset Code">{asset && asset.assetCode} /{asset && asset.altName || '---'} /{asset && asset.ownerCode || '---'}</Descriptions.Item>
                <Descriptions.Item
                  label="Equipment Sub Type">{equipmentSubType && equipmentSubType.name}</Descriptions.Item>
                <Descriptions.Item
                  label="Asset Model">{asset && asset.assetModel && asset.assetModel.name}</Descriptions.Item>
                <Descriptions.Item
                  label="Equipment Type">{equipmentSubType && equipmentSubType.assetType && equipmentSubType.assetType.name}</Descriptions.Item>
                <Descriptions.Item label="Owner">{owner && owner.name}</Descriptions.Item>
                <Descriptions.Item label="Total Cost of Ownership Till Date" span={1}>
                  {totalAssetCost >= 0 && totalAssetCost.toLocaleString('en-IN', {
                    maximumFractionDigits: 2,
                    style: 'currency',
                    currency: 'INR'
                  })}
                </Descriptions.Item>
                <Descriptions.Item label="Days Since Operation" span={1}>
                  {asset && asset.status === 'SOLD' ? saleOrder && moment(saleOrder.saleDate).diff(moment(purchaseOrder && purchaseOrder.invoiceDate), 'days') :
                    purchaseOrder && moment().diff(moment(purchaseOrder && purchaseOrder.invoiceDate), 'days')
                  }
                </Descriptions.Item>
                <Descriptions.Item label="Alt Name"
                  span={1}>{(asset && asset.altName) || "None"}</Descriptions.Item>
                <Descriptions.Item label="Description"
                  span={1}>{(asset && asset.description) || "None"}</Descriptions.Item>
                <Descriptions.Item
                  label="Present Location">
                  {(asset && asset.location && asset.location.name) || asset && asset.status}
                  {asset && asset.status && asset.status === 'SOLD' && <Link target={'_blank'} to={`/sale-order/view/${saleOrder && saleOrder._id}`}><Icon style={{ marginLeft: '10px', color: 'tomato' }} type="select" />  </Link>}
                </Descriptions.Item>
                <Descriptions.Item
                  label="Present Sub Location">{(asset && asset.client && asset.client.name) || "None"}
                  {asset && asset.employeeId && asset.employeeId.name && (
                    <Link target={'_blank'} to={`/manpower/view/${asset.employeeId._id}`}>
                      {` (${asset.employeeId.name})`}
                    </Link>
                  )}</Descriptions.Item>
                <Descriptions.Item
                  label="Last Located">{(lastLocated && lastLocated.format('DD-MM-YYYY hh:mm a')) || "NA"}</Descriptions.Item>
                <Descriptions.Item
                  label="Custodian" span={1}>{(asset && asset.custodian && asset.custodian.name) || "None"}</Descriptions.Item>
                <Descriptions.Item label="Speed Limit">
                  {asset && asset.speedLimit && (<span style={{ color: 'red' }}>{asset.speedLimit.toFixed(2) + ' Km/h'}</span>) || <span>Not Set</span>}
                </Descriptions.Item>
                <Descriptions.Item label="Manual Refuel Report">
                  <FuelManualReportLink data={data} authUser={this.props.authUser} />
                </Descriptions.Item>
                <Descriptions.Item label="Fuel Calibration & Setting" span={2}>
                  <FuelCalibrationLink data={data} authUser={this.props.authUser} />

                </Descriptions.Item>
                {findLinkedIotDevice(data) && (
                  <Descriptions.Item label="IoT Tickets" span={3}>
                    <OpsTicketsButton data={data} authUser={this.props.authUser} />
                  </Descriptions.Item>
                )}

              </Descriptions>
            </div>

            <Collapse bordered={false} style={{ marginTop: '12px' }}>
              <Panel header={
                <Row className='job-card-row'>
                  <Col xs={24} sm={12} md={8} lg={6}>
                    <div className='job-card-details'>
                      <div className='content-row-style'>Documents ({Object.keys(groupedDocuments).length} types)</div>
                    </div>
                  </Col>

                  <Col xs={24} sm={12} md={8} lg={6}>
                    <div className='job-card-details'>
                      <div className='content-row-style'>No. of Documents Attached:</div>
                      <div>&nbsp;{asset && asset.documents && asset.documents.length}</div>
                    </div>
                  </Col>

                  <Col xs={24} sm={12} md={8} lg={6}>
                    <div className='job-card-details'>
                      <div className='content-row-style'>Total Document Cost:</div>
                      <div>&nbsp;{documentCost >= 0 && documentCost.toLocaleString('en-IN', {
                        maximumFractionDigits: 2,
                        style: 'currency',
                        currency: 'INR'
                      }) || <span>&#8377;0.00</span>}</div>
                    </div>
                  </Col>
                </Row>
              } key="documents">

                {Object.entries(groupedDocuments).map(([docType, documents]) => (
                  <Collapse key={docType} bordered={false} style={{ marginBottom: '12px' }}>
                    <Panel
                      header={
                        <Row>
                          <Col span={24}>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                              <span style={{ fontWeight: 'bold' }}>{docType || 'Unknown'}</span>
                              <span>({documents.length} documents)</span>
                            </div>
                          </Col>
                        </Row>
                      }
                    >
                      <Table
                        dataSource={documents}
                        columns={documentColumns}
                        pagination={false}
                      />
                    </Panel>
                  </Collapse>
                ))}


                {/* {(assetDocuments && assetDocuments.length > 0 &&
                  <Table dataSource={assetDocuments || []} columns={documentColumns || []}
                    pagination={false} />) || "No documents found!"} */}
              </Panel>
            </Collapse>

            <div>
              <Collapse bordered={false}>
                <Panel header={
                  <Row className='job-card-row'>
                    <Col xs={24} sm={12} md={8} lg={6}>
                      <div className='job-card-details'>
                        <div className='content-row-style'>Purchased Details</div>
                      </div>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={6}>
                      <div className='job-card-details'>
                        <div className='content-row-style'>Total Purchase Cost:</div>
                        <div>&nbsp;{purchaseOrderCostData >= 0 && purchaseOrderCostData.toLocaleString('en-IN', {
                          maximumFractionDigits: 2,
                          style: 'currency',
                          currency: 'INR'
                        }) || <span>&#8377;0.00</span>}</div>
                      </div>
                    </Col>
                  </Row>
                } key="purchasedDetails">
                  {(purchaseOrder && <Descriptions
                    layout='vertical'
                    bordered
                    column={{ xxl: 6, xl: 6, lg: 6, md: 3, sm: 2, xs: 1 }}
                  >
                    <Descriptions.Item
                      label="Date of Purchase">{moment(purchaseOrder && purchaseOrder.invoiceDate).format('DD-MM-YYYY')}</Descriptions.Item>
                    <Descriptions.Item
                      label="Purchase Register Ref"><Button
                        onClick={this.linkHandler.bind(this, purchaseOrder && purchaseOrder._id, 'purchase-order', 'edit')}>{'Open ' + (purchaseOrder && purchaseOrder.poNo)}</Button></Descriptions.Item>
                    <Descriptions.Item
                      label="Invoice No.">{purchaseOrder && purchaseOrder.invoiceNumber}</Descriptions.Item>
                    <Descriptions.Item
                      label="Vendor Name">{(purchaseOrder && purchaseOrder.vendor && purchaseOrder.vendor.name) || "NA"}</Descriptions.Item>
                    <Descriptions.Item label="Cost">
                      {purchaseOrderCost >= 0 && purchaseOrderCost.toLocaleString('en-IN', {
                        maximumFractionDigits: 2,
                        style: 'currency',
                        currency: 'INR'
                      })}
                    </Descriptions.Item>
                    <Descriptions.Item label='Readings'>
                      {(purchaseOrderReadings && purchaseOrderReadings.length > 0 && <Dropdown
                        overlay={this.dropdownData.bind(this, purchaseOrderReadings, false, false)}
                        trigger={['click']}>
                        <a className="ant-dropdown-link" href="#">
                          Click Here <Icon type="down" />
                        </a>
                      </Dropdown>) || "None"}
                    </Descriptions.Item>
                  </Descriptions>) || (parentLinkedAsset && parentLinkedAsset.purchaseOrder &&
                    <Descriptions
                      layout='vertical'
                      bordered
                      column={{ xxl: 6, xl: 6, lg: 6, md: 3, sm: 2, xs: 1 }}
                    >
                      <Descriptions.Item
                        label="Date of Purchase">{moment(parentLinkedAsset && parentLinkedAsset.purchaseOrder && parentLinkedAsset.purchaseOrder.invoiceDate).format('DD-MM-YYYY')}</Descriptions.Item>
                      <Descriptions.Item
                        label="Purchase Register Ref"><Button
                          onClick={this.linkHandler.bind(this, parentLinkedAsset && parentLinkedAsset.purchaseOrder && parentLinkedAsset.purchaseOrder._id, 'purchase-order', 'edit')}>{'Open ' + (parentLinkedAsset && parentLinkedAsset.purchaseOrder && parentLinkedAsset.purchaseOrder.poNo)}</Button></Descriptions.Item>
                      <Descriptions.Item
                        label="Invoice No.">{parentLinkedAsset && parentLinkedAsset.purchaseOrder && parentLinkedAsset.purchaseOrder.invoiceNumber}</Descriptions.Item>
                      <Descriptions.Item
                        label="Vendor Name">{(parentLinkedAsset && parentLinkedAsset.purchaseOrder && parentLinkedAsset.purchaseOrder.vendor && parentLinkedAsset.purchaseOrder.vendor.name) || "NA"}</Descriptions.Item>
                      {/*<Descriptions.Item label="Parent Cost">*/}
                      {/*  {parentLinkedAssetPurchaseOrderCost >= 0 && parentLinkedAssetPurchaseOrderCost.toLocaleString('en-IN', {*/}
                      {/*    maximumFractionDigits: 2,*/}
                      {/*    style: 'currency',*/}
                      {/*    currency: 'INR'*/}
                      {/*  })}*/}
                      {/*</Descriptions.Item>*/}
                      <Descriptions.Item label="Cost">
                        {(0).toLocaleString('en-IN', {
                          maximumFractionDigits: 2,
                          style: 'currency',
                          currency: 'INR'
                        })}
                      </Descriptions.Item>
                      <Descriptions.Item label='Parent Readings'>
                        {(parentPurchaseOrderReadings && parentPurchaseOrderReadings.length > 0 &&
                          <Dropdown
                            overlay={this.dropdownData.bind(this, parentPurchaseOrderReadings, false, false)}
                            trigger={['click']}>
                            <a className="ant-dropdown-link" href="#">
                              Click Here <Icon type="down" />
                            </a>
                          </Dropdown>) || "None"}
                      </Descriptions.Item>
                    </Descriptions>) || "No purchase details found!"}
                </Panel>

                {/* Asset Movement History */}
                <Panel header={
                  <Row className='job-card-row'>
                    <Col xs={24} sm={12} md={12} lg={12}>
                      <div className='job-card-details'>
                        <div className='content-row-style'>Movement History</div>
                      </div>
                    </Col>
                  </Row>
                } key="2">

                  {/* Ata and ARN*/}
                  <Collapse bordered={false}>
                    <Panel header={
                      <Row className='job-card-row'>
                        <Col xs={24} sm={12} md={12} lg={12}>
                          <div className='job-card-details'>
                            <div className='content-row-style'>ATA & ARN Details</div>
                          </div>
                        </Col>
                      </Row>
                    } key="1">
                      {(movementData && movementData.ata && movementData.ata.length > 0 &&
                        <Table dataSource={movementTableData || []}
                          columns={movementColumns || []}
                          pagination={false} />) || "No ATA & ARN details found!"}
                    </Panel>
                  </Collapse>

                  {/* EAI */}
                  <Collapse bordered={false}>
                    <Panel header={
                      <Row className='job-card-row'>
                        <Col xs={24} sm={12} md={12} lg={12}>
                          <div className='job-card-details'>
                            <div className='content-row-style'>Employee Asset Issue Details
                            </div>
                          </div>
                        </Col>
                      </Row>
                    } key="1">
                      {(movementData && movementData.eai && movementData.eai.length > 0 &&
                        <Table dataSource={movementEaiData || []}
                          columns={eaiColumns || []}
                          pagination={false} />) || "No Employee Asset Issue history found!"}
                    </Panel>
                  </Collapse>

                  {/* EAR */}
                  <Collapse bordered={false}>
                    <Panel header={
                      <Row className='job-card-row'>
                        <Col xs={24} sm={12} md={12} lg={12}>
                          <div className='job-card-details'>
                            <div className='content-row-style'>Employee Asset Receipt
                              Details
                            </div>
                          </div>
                        </Col>
                      </Row>
                    } key="1">
                      {(movementData && movementData.ear && movementData.ear.length > 0 &&
                        <Table dataSource={movementEarData || []} columns={earColumns || []}
                          pagination={false} />) || "No Employee Asset Receipt history found!"}
                    </Panel>
                  </Collapse>

                </Panel>

                <Panel header={
                  <Row className='job-card-row'>
                    <Col xs={24} sm={12} md={8} lg={6}>
                      <div className='job-card-details'>
                        <div className='content-row-style'>Maintenance Details</div>
                      </div>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={6}>
                      <div className='job-card-details'>
                        <div className='content-row-style'>Total Maintenance Cost:</div>
                        <div>&nbsp;{jobCardTotalCost >= 0 && jobCardTotalCost.toLocaleString('en-IN', {
                          maximumFractionDigits: 2,
                          style: 'currency',
                          currency: 'INR'
                        }) || <span>&#8377;0.00</span>}</div>
                      </div>
                    </Col>
                  </Row>
                } key="maintenanceDetails">
                  {(jobCards && jobCards.length > 0 &&
                    <Table dataSource={jobCardsData || []} columns={jobCardsColumns || []}
                      pagination={false} />) || "No maintenance records found!"}
                </Panel>

                <Panel header={
                  <Row className='job-card-row'>
                    <Col xs={24} sm={12} md={8} lg={3}>
                      <div className='job-card-details'>
                        <div className='content-row-style'>Asset Servicing</div>
                      </div>
                    </Col>
                  </Row>
                } key="assetServicing">

                  <Descriptions
                    layout='vertical'
                    bordered
                    column={{ xxl: 6, xl: 6, lg: 6, md: 3, sm: 2, xs: 1 }}
                  >
                    <Descriptions.Item
                      label="Service Date">{(assetServicing && assetServicing.createdAt && moment(assetServicing.createdAt).format('DD-MM-YYYY')) || "NA"}</Descriptions.Item>
                    <Descriptions.Item label='Readings'>
                      {(assetServicingReadings && assetServicingReadings.length > 0 &&
                        <Dropdown
                          overlay={this.dropdownData.bind(this, assetServicingReadings, false, false)}
                          trigger={['click']}>
                          <a className="ant-dropdown-link" href="#">Click Here <Icon
                            type="down" /></a>
                        </Dropdown>) || "None"}
                    </Descriptions.Item>
                  </Descriptions>
                </Panel>

                <Panel header={
                  <Row className='job-card-row'>
                    <Col xs={24} sm={12} md={8} lg={5}>
                      <div className='job-card-details'>
                        <div className='content-row-style'>Asset Refurbishment</div>
                      </div>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={6}>
                      <div className='job-card-details'>
                        <div className='content-row-style'>Total Cost:</div>
                        <div>&nbsp;{assetRefurbishmentCost >= 0 && assetRefurbishmentCost.toLocaleString('en-IN', {
                          maximumFractionDigits: 2,
                          style: 'currency',
                          currency: 'INR'
                        }) || <span>&#8377;0.00</span>}</div>
                      </div>
                    </Col>
                  </Row>
                } key="assetRefurbishmentData">
                  {(assetRefurbishment && assetRefurbishment.length > 0 &&
                    <Table dataSource={assetRefurbishmentData || []}
                      columns={assetRefurbishmentColumns || []}
                      pagination={false} />) || "No asset refurbishment details found!"}
                </Panel>

                <Panel header={
                  <Row className='job-card-row'>
                    <Col xs={24} sm={12} md={8} lg={6}>
                      <div className='job-card-details'>
                        <div className='content-row-style'>Parent Linked Asset</div>
                      </div>
                    </Col>
                  </Row>
                } key="parentLinkedAsset">

                  {/* Old Parent Linked Asset implementation retained as requested
                  {(parentLinkedAsset && <Descriptions
                    layout='vertical'
                    bordered
                    column={{ xxl: 6, xl: 6, lg: 6, md: 3, sm: 2, xs: 1 }}
                  >
                    <Descriptions.Item
                      label="Linked Asset No."><Button
                        onClick={this.linkHandler.bind(this, parentLinkedAsset && parentLinkedAsset._id, 'asset', 'history-report')}>{'Open ' + (parentLinkedAsset && parentLinkedAsset.assetCode)}</Button></Descriptions.Item>
                    <Descriptions.Item
                      label="Equipment Sub Type">{parentLinkedAsset.equipmentSubType && parentLinkedAsset.equipmentSubType.name}</Descriptions.Item>
                    <Descriptions.Item
                      label="Equipment Type">{parentLinkedAsset.equipmentSubType && parentLinkedAsset.equipmentSubType.assetType && parentLinkedAsset.equipmentSubType.assetType.name}</Descriptions.Item>
                    <Descriptions.Item
                      label="Linked On">{(!isNaN(Date.parse(parentLinkedAsset.linkedOn)) && moment(parentLinkedAsset.linkedOn).format('DD-MM-YYYY')) || parentLinkedAsset.linkedOn}</Descriptions.Item>
                    <Descriptions.Item
                      label="Delinked On">{(!isNaN(Date.parse(parentLinkedAsset.delinkedOn)) && moment(parentLinkedAsset.delinkedOn).format('DD-MM-YYYY')) || parentLinkedAsset.delinkedOn}</Descriptions.Item>
                    <Descriptions.Item label="SBT Ref No.">HARDCODED PLACEHOLDER</Descriptions.Item>
                    <Descriptions.Item label='Asset Refurbishments'>
                      {(parentLinkedAsset.assetRefurbishments && parentLinkedAsset.assetRefurbishments.length > 0 &&
                        <Table dataSource={parentRefurbishmentData || []}
                          columns={assetRefurbishmentColumns || []}
                          pagination={false}
                          bordered />) || "No parent linked asset refurbishments found!"}
                    </Descriptions.Item>
                  </Descriptions>) || "No parent linked asset found!"}
                  */}

                  {(parentHistoryData && parentHistoryData.length > 0 &&
                    <Table
                      dataSource={parentHistoryData || []}
                      columns={parentHistoryColumns || []}
                      pagination={false}
                    />) || "No parent linked asset history found!"}
                </Panel>

                <Panel header={
                  <Row className='job-card-row'>
                    <Col xs={24} sm={12} md={8} lg={5}>
                      <div className='job-card-details'>
                        <div className='content-row-style'>Dependent Linked Asset</div>
                      </div>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={6}>
                      <div className='job-card-details'>
                        <div className='content-row-style'>Total Cost:</div>
                        <div>&nbsp;{totalDependentCost >= 0 && totalDependentCost.toLocaleString('en-IN', {
                          maximumFractionDigits: 2,
                          style: 'currency',
                          currency: 'INR'
                        }) || <span>&#8377;0.00</span>}
                        </div>
                      </div>
                    </Col>
                  </Row>
                } key="dependentLinkedAsset">
                  {(dependentHistoryData && dependentHistoryData.length > 0 &&
                    <Table
                      dataSource={dependentHistoryData || []}
                      columns={dependentHistoryColumns || []}
                      pagination={false}
                    />) || "No dependent linked assets found!"}
                </Panel>

                <Panel header={
                  <Row className='job-card-row'>
                    <Col xs={24} sm={12} md={8} lg={6}>
                      <div className='job-card-details'>
                        <div className='content-row-style'>Sale Details</div>
                      </div>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={6}>
                      <div className='job-card-details'>
                        <div className='content-row-style'>Total Sales Cost:</div>
                        <div>&nbsp;{saleOrderCost >= 0 && saleOrderCost.toLocaleString('en-IN', {
                          maximumFractionDigits: 2,
                          style: 'currency',
                          currency: 'INR'
                        }) || <span>&#8377;0.00</span>}
                        </div>
                      </div>
                    </Col>
                  </Row>
                } key="salesDetails">

                  {(saleOrder && <Descriptions
                    layout='vertical'
                    bordered
                    column={{ xxl: 6, xl: 6, lg: 6, md: 3, sm: 2, xs: 1 }}
                  >
                    <Descriptions.Item
                      label="Date of Sale">{moment(saleOrder.saleDate).format('DD-MM-YYYY')}</Descriptions.Item>
                    <Descriptions.Item
                      label="Sales Register Ref"><Button
                        onClick={this.linkHandler.bind(this, saleOrder._id, 'sale-order', 'edit')}>{'Open ' + (saleOrder && saleOrder.soNo)}</Button></Descriptions.Item>
                    <Descriptions.Item
                      label="Invoice No.">{purchaseOrder && purchaseOrder.invoiceNumber}</Descriptions.Item>
                    <Descriptions.Item
                      label="Buyer Name">{saleOrder.vendor && saleOrder.vendor.name}</Descriptions.Item>
                    <Descriptions.Item
                      label="Cost">{saleOrderAsset && saleOrderAsset.rate.toLocaleString('en-IN', {
                        maximumFractionDigits: 2,
                        style: 'currency',
                        currency: 'INR'
                      })}</Descriptions.Item>
                    <Descriptions.Item label='Readings'>
                      <Dropdown
                        overlay={this.dropdownData.bind(this, saleOrderReadings, false, false)}
                        trigger={['click']}>
                        <a className="ant-dropdown-link" href="#">Click Here <Icon type="down" /></a>
                      </Dropdown>
                    </Descriptions.Item>
                  </Descriptions>) || "No sale details found!"}
                </Panel>

                <Panel header={
                  <Row className='job-card-row'>
                    <Col xs={24} sm={12} md={8} lg={6}>
                      <div className='job-card-details'>
                        <div className='content-row-style'>Asset Verification</div>
                      </div>
                    </Col>
                  </Row>
                } key="assetStockTaking">

                  <Table
                    dataSource={assetStockTakingForVerification || []}
                    columns={assetStockTakingColumn || []}
                    pagination={false}
                  />
                </Panel>

                {fuelConsumptionRateHistory.length > 0 && (
                  <Panel header={
                    <Row className='job-card-row'>
                      <Col xs={24} sm={12} md={8} lg={6}>
                        <div className='job-card-details'>
                          <div className='content-row-style'>Standard Fuel Consumption Rate History</div>
                        </div>
                      </Col>
                    </Row>
                  } key="fuelConsumptionRateHistory">
                    <Table
                      dataSource={fuelConsumptionRateHistory}
                      columns={this.fuelConsumptionRateHistoryColumns}
                      pagination={false}
                    />
                  </Panel>
                )}
              </Collapse>
            </div>
          </Spin>
        </Card>

        <MapView isVisible={this.state.isMapVisible} hideVisible={this.hideMapVisible} data={this.state.mapData} />
        <ImagePreviewModal
          visible={this.state.photoPreview.visible}
          photos={this.state.photoPreview.photos}
          initialIndex={this.state.photoPreview.index}
          onClose={this.closePhotoPreview}
        />
      </>
    );
  }
}

export default HistoryReport;
